var _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageMasking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2561_264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 33,
    width: 213,
    height: 109
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.034 33.0264C173.93 33.0264 173.034 33.9218 173.034 35.0264V45.717C173.034 46.8216 172.139 47.717 171.034 47.717H39.155C38.9757 47.717 38.802 47.7406 38.6367 47.7849C38.2872 47.8784 37.9381 47.9998 37.5763 47.9998H11C9.89543 47.9998 9 48.8952 9 49.9998V72.9998C9 74.1043 9.89543 74.9998 11 74.9998H35.155C36.2596 74.9998 37.155 75.8952 37.155 76.9998V108.824C37.155 109.09 37.0892 109.35 37.0378 109.611C37.013 109.737 37 109.867 37 110V140C37 141.104 37.8954 142 39 142H188C189.105 142 190 141.104 190 140V128.062C190 126.957 190.895 126.062 192 126.062H219.999C221.104 126.062 221.999 125.166 221.999 124.062V55.3812C222 55.3676 222 55.3539 222 55.3402V35.0264C222 33.9218 221.104 33.0264 220 33.0264H175.034Z",
    fill: "#718095",
    fillOpacity: 0.38
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2561_264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.32812,
    y: 24.458,
    width: 242.379,
    height: 133.431,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.35
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.223 92H80.7623C78.1005 92 78 93.1193 78 94.5C78 95.8807 78.1005 97 80.7623 97H173.223C175.885 97 176 95.8807 176 94.5C176 93.1193 175.885 92 173.223 92Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.442 85H102.55C101.056 85 101 86.1193 101 87.5C101 88.8807 101.056 90 102.55 90H154.442C155.935 90 156 88.8807 156 87.5C156 86.1193 155.935 85 154.442 85Z",
    fill: "#D1D5DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMasking);
export default __webpack_public_path__ + "static/media/image_masking.6ed3de06facfc08c2e3d02888600402e.svg";
export { ForwardRef as ReactComponent };